import { restClient } from '../../client';

export type PatientRegistrationInput = {
  email: string;
  password: string;
  first_name: string;
  last_name: string;
  preferred_first_name: string;
  referrer?: string;
  provider_id?: string;
  utm_source?: string;
  utm_id?: string;
  utm_params?: Record<string, string>;
};

export type PatientRegistrationOutput = {
  status: string;
  match_id: string;
  access_token: string;
  refresh_token: string;
  user_id: string;
} | {
  status: 'email_error' | 'password_error';
  error: string;
};

export const patientRegistration = (params: PatientRegistrationInput) => restClient.request<PatientRegistrationOutput>('/onboarding/client_register', {
  method: 'POST',
  data: params
});
